<template>
  <div></div>
</template>

<script>
import { reactive, toRefs, onMounted } from 'vue'
import { Dialog, Toast } from 'vant'
import { getUsersPrefs, bindBOUser, getUserByToken } from '@/api/wx'
import { useRoute, useRouter } from 'vue-router'
export default {
  setup() {
    const route = useRoute()
    const router = useRouter()
    const state = reactive({
      query: route.query
    })
    // 未绑定用户进行绑定
    const bind = async () => {
      let { token } = state.query
      try {
        let data = await getUserByToken(token)
        let user = data || {}
        let userDesc = user.dealer ? `${user.dealer} - ${user.role} - ${user.name}` : `${user.role} - ${user.name}`
        Dialog.alert({
          title: '绑定后台用户',
          message: `确定要将您的微信账户与后台账户${userDesc}绑定吗？`
        })
          .then(async () => {
            try {
              let bindResult = await bindBOUser(token)
              if (bindResult.success) {
                Toast.success('绑定成功！')
                setTimeout(() => {
                  router.push({
                    path: '/',
                    event: '绑定账号成功'
                  })
                }, 2000)
              }
            } catch (e) {
              let message = e.message || '请求出现错误，请扫码重试。'
              Dialog.alert({
                title: '绑定后台用户',
                message
              })
            }
          })
          .catch(() => {
            router.push({
              path: '/',
              event: '绑定失败'
            })
          })
      } catch (error) {
        let message = error?.message || '请求出现错误，请扫码重试。'
        Dialog.alert({
          title: '绑定后台用户',
          message
        }).then(() => {
          router.push({
            path: '/',
            event: '已绑定'
          })
        })
      }
    }
    // 绑定提示
    const hasBind = () => {
      Dialog.alert({
        title: '绑定后台用户',
        message: '您当前账户已绑定后台账户，若要绑定其他账户，需先在后台解绑当前账户'
      }).then(() => {
        router.push({
          path: '/',
          event: '已绑定'
        })
      })
    }
    onMounted(async () => {
      // 获取用户信息
      let data = await getUsersPrefs()
      data.bo_account ? hasBind() : bind()
    })
    return {
      ...toRefs(state)
    }
  }
}
</script>

<style lang="scss" scoped></style>
